export enum AvailabilityPluginDataHooks {
  ROOT = 'availability-plugin-root',
}
